import { takeLatest, put, call } from 'redux-saga/effects';
import request from '../../components/Utils/httpHelper';
import * as corporateBillingMasterActions from './action';
import { CORE_API } from '../../config';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants'

export function* corporateBillingMasterTemplateRequest(action) {
    let requestURL = `${CORE_API}/corporate-billing/masters/template`;

    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(corporateBillingMasterActions.corporateBillingMasterTemplateSuccess({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(corporateBillingMasterActions.corporateBillingMasterTemplateFailure({ ...err.response, status: "FAILURE" }))
    }
}

export function* corporateBillingMasterTemplate() {
    yield takeLatest(corporateBillingMasterActions.CORPORATE_BILLING_MASTER_TEMPLATE_REQUEST, corporateBillingMasterTemplateRequest);
}

export function* submitCorporateBillingMasterRequestSaga(action) {
    const formData = new FormData();
    formData.append('file', action.data.file);
    let requestUrl = "";
    let methodtype = "";
    if(action.data.type === 'add'){
        methodtype="POST"
        requestUrl = `${CORE_API}/corporate-billing/masters`;
    }
    if(action.data.type === 'edit'){
         methodtype="PUT"
        requestUrl = `${CORE_API}/corporate-billing/masters`;
    }
    try {
        const searchResult = yield call(request, requestUrl, { data: formData, method: methodtype, headers: HTTP_HEADERS_FORMDATA, responseType: 'blob' });
        
        // Check if response is JSON or Blob
        if (searchResult.data instanceof Blob && searchResult.data.type === 'application/json') {
            // It's a JSON blob, convert to JSON
            const text = yield searchResult.data.text();
            const jsonData = JSON.parse(text);
            yield put(corporateBillingMasterActions.addCorporateBillingMasterUploadSuccess(jsonData));
        } else if (searchResult.data instanceof Blob) {
            // Binary response (shouldn't happen on success, but handle it)
            const text = yield searchResult.data.text();
            const jsonData = JSON.parse(text);
            yield put(corporateBillingMasterActions.addCorporateBillingMasterUploadSuccess(jsonData));
        } else {
            // Direct JSON response
            yield put(corporateBillingMasterActions.addCorporateBillingMasterUploadSuccess(searchResult.data));
        }
    } catch (err) {
        // Check if error response is Excel file or JSON
        if (err.response && err.response.data instanceof Blob) {
            const contentType = err.response.data.type;
            
            // Backend returns Excel errors as application/octet-stream
            if (contentType && (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || 
                contentType.includes('application/octet-stream'))) {
                // It's an Excel file - convert to ArrayBuffer
                const arrayBuffer = yield err.response.data.arrayBuffer();
                yield put(corporateBillingMasterActions.addCorporateBillingMasterUploadFailureFile(arrayBuffer));
            } else if (contentType && contentType.includes('application/json')) {
                // It's a JSON error
                const text = yield err.response.data.text();
                const jsonError = JSON.parse(text);
                yield put(corporateBillingMasterActions.addCorporateBillingMasterUploadFailure(jsonError));
            } else {
                // Unknown blob type, try to read as text
                const text = yield err.response.data.text();
                try {
                    const jsonError = JSON.parse(text);
                    yield put(corporateBillingMasterActions.addCorporateBillingMasterUploadFailure(jsonError));
                } catch (parseErr) {
                    yield put(corporateBillingMasterActions.addCorporateBillingMasterUploadFailure({ message: text || "Upload failed" }));
                }
            }
        } else {
            // Regular error message
            yield put(corporateBillingMasterActions.addCorporateBillingMasterUploadFailure(err.response?.data || { message: "Upload failed" }));
        }
    }
}

export function* submitCorporateBillingMasterRequest() {
    yield takeLatest(corporateBillingMasterActions.ADD_CORPORATE_BILLING_MASTER_UPLOAD, submitCorporateBillingMasterRequestSaga);
}


export function* corporateBillingMasterDataExcelRequest(action) {
    let requestURL = `${CORE_API}/corporate-billing/masters/export`;

    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(corporateBillingMasterActions.corporateBillingMasterDataExcelSuccess({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(corporateBillingMasterActions.corporateBillingMasterDataExcelFailure({ ...err.response, status: "FAILURE" }))
    }
}

export function* corporateBillingMasterDataExcel() {
    yield takeLatest(corporateBillingMasterActions.CORPORATE_BILLING_MASTER_DATA_EXCEL_REQUEST, corporateBillingMasterDataExcelRequest);
}
